<template>
    <tr>
        <td>
            #{{ company.id }}
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.name }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="name" placeholder="Lot start #"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.auction }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="auction" placeholder="Until lot #"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.yokohama }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="yokohama" placeholder="Delivery to Yokohama"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.yokohama_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="yokohama_sales" placeholder="Delivery to Yokohama"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.nagoya }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="nagoya" placeholder="Delivery to Nagoya"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.nagoya_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="nagoya_sales" placeholder="Delivery to Nagoya"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.kobe }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="kobe" placeholder="Delivery to Kobe"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.kobe_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="kobe_sales" placeholder="Delivery to Kobe"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.hakata }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="hakata" placeholder="Delivery to Hakata"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.hakata_sales }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="hakata_sales" placeholder="Delivery to Hakata"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ company.info }}</span>
            <input class="input is-small" v-if="checkIfEditEnabled" v-model="info" placeholder="Comment"/>
        </td>
        <td>
            <button v-if="checkIfEditEnabled" class="button is-link" @click="updatePrice()">
                <i class="fas fa-save"></i>
            </button>
            <button  v-if="!checkIfEditEnabled" class="button" @click="editPrice(company)">
                <i class="fas fa-edit"></i>
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        props: ['company'],
        methods: {
            editPrice(company){
                this.$store.dispatch('setSelectedInlandCompany', company)
            },
            updatePrice() {
                this.$store.dispatch('updateInlandCompany')
                this.$store.dispatch('fetchAllInlandCompanies')
            }
        },
        computed: {
            checkIfEditEnabled() {
                return this.$store.getters.getSelectedInlandCompany.id === this.company.id
            },
            name: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.name
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'name', value: value})
                }
            },
            auction: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.auction
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'auction', value: value})
                }
            },
            yokohama: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.yokohama
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'yokohama', value: value})
                }
            },
            yokohama_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.yokohama_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'yokohama_sales', value: value})
                }
            },
            nagoya: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.nagoya
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'nagoya', value: value})
                }
            },
            nagoya_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.nagoya_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'nagoya_sales', value: value})
                }
            },
            kobe: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.kobe
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'kobe', value: value})
                }
            },
            kobe_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.kobe_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'kobe_sales', value: value})
                }
            },
            hakata: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.hakata
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'hakata', value: value})
                }
            },
            hakata_sales: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.hakata_sales
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'hakata_sales', value: value})
                }
            },
            info: {
                get() {
                    return this.$store.getters.getSelectedInlandCompany.info
                },
                set(value) {
                    this.$store.dispatch('setInlandCompanyFieldValue', {field: 'info', value: value})
                }
            }
        },
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
        background-color: whitesmoke;
    }
    .is-responsive-table td {
        font-size: 10px;
    }
    .image {
        max-height: 32px;
        height: 32px;
        padding-left: 2px;
    }
    .is-automatic {
        background-color: rgba(0, 255, 255, 0.25);
    }
    .is-real {
        background-color: rgba(255, 255, 0, 0.27);
    }
    .is-win {

    }
    .is-canceled {

    }
    .nowrap {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .is-responsive-table table {
        width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/InlandComapnies/InlandCompanyTableRow.vue